import { NavLink } from "react-router";

import parse from 'html-react-parser';
import type { Traductions } from "../../types/Traductions";
import { useTrads } from "../../contexts/trads/useTrads";


function TraductionsItem({traduction}:{traduction:Traductions}) {
    const {translate}=useTrads();


    return (
        <div className="row">
            <h2>{traduction.name}</h2>
            <div>
                {parse(traduction.value)}
            </div>
            <NavLink to={`/traductions/${traduction.id.toString()}/edit`}> {translate('btn_edit')}</NavLink>
        </div>
    );
}
export default TraductionsItem;